<template>
    <img
        v-if="manufacturer.logo?.external_id"
        class="hidden at1024:block at1024:sticky top-56 w-[180px] at1200:ml-8"
        :src="marketingAssetUrl(manufacturer.logo.external_id)"
        :alt="manufacturer.name + ' image'"
    />
    <div class="at1024:w-[calc(100%_-_212px)] at1200:w-[calc(100%_-_276px)]">
        <Link :href="route('web.catalog.price-books.show', manufacturer)" class="flex w-fit hover:underline underline-offset-4">
            <h1 class="flex w-fit font-bold text-2xl at1024:text-3xl pb-4 pl-4">
                {{ manufacturer.name }}
            </h1>
        </Link>
        <!-- No price book -->
        <div
            v-if="!manufacturer.resources['Price Books']?.length"
            class="text-left text-gray-400 m-4"
        >
            {{ $t("Call for pricing", { phone: "800-847-5625" }) }}
        </div>
        <div v-for="(section, key) in sortedResources" class="border-t">
            <h3 class="text-gray-400 m-4 mt-6">{{ key }}</h3>
            <ul class="mb-4">
                <li
                    v-for="file in section?.sort((a, b) =>
                        a.name?.localeCompare(b.name)
                    )"
                    class="flex gap-6 items-start px-4 py-3 hover:bg-gray-125"
                >
                    <span class="flex mr-auto">
                        <BaseSvg
                            class="h-6 mr-3 mt-px shrink-0 w-6"
                            :name="config.resources.icons[key] ?? 'icon-document'"
                            aria-hidden="true"
                        />
                        <a
                            :href="marketingAssetUrl(file.asset.external_id)"
                            class="leading-tight underline-offset-4 hover:underline"
                            target="_blank"
                        >
                            {{ file.name }}
                        </a>
                    </span>
                    <span
                        class="hidden shrink-0 text-right w-24 whitespace-nowra at1024:block"
                    >
                        {{
                            file?.asset?.updated_at
                                ? DateTime.fromISO(
                                      file?.asset?.updated_at
                                  ).toLocaleString(DateTime.DATE_MED)
                                : "–"
                        }}
                    </span>
                    <button
                        @click.stop.prevent="
                            forceDownload(
                                $event,
                                marketingAssetUrl(file.asset.external_id),
                                _.kebabCase(file.name) + '.pdf'
                            )
                        "
                        class="group hidden -translate-y-px at1024:block"
                    >
                        <BaseSvg
                            name="icon-export-file"
                            class="shrink-0 fill-black group-hover:fill-red"
                            aria-hidden="true"
                        />
                        <span class="sr-only">Download the {{ file.name }}</span>
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { DateTime } from "luxon";
import { BaseSvg } from "@/Components";
import { useAssetTransforms, useDownload } from "@/Composables";
import { computed } from "vue";
import _ from "lodash";
import config from "@/config";

const { forceDownload } = useDownload();

const { marketingAssetUrl } = useAssetTransforms();

const props = defineProps(["manufacturer"]);

const sortedResources = computed(() => {
    let sortedKeys = _.sortBy(Object.keys(props.manufacturer.resources));
    return _.pick(props.manufacturer.resources, sortedKeys);
});
</script>
